/**
 * ⚠️ ARQUIVO PROTEGIDO
 * 
 * Este arquivo contém TODAS as chamadas de API do dashboard do Super Admin.
 * Tokens e headers ficam ENCAPSULADOS aqui.
 * 
 * NUNCA faça chamadas de API diretamente nos componentes!
 */

import type {
  DashboardStats,
  DispatchesTimelineResponse,
  TopTenantsResponse
} from '../../types/superadmin/dashboard.types';

class DashboardApiService {
  private readonly baseUrl = '/api/superadmin/dashboard';

  /**
   * Helper privado para fazer requisições autenticadas
   * Tokens ficam protegidos aqui
   */
  private async authenticatedFetch(url: string, options: RequestInit = {}): Promise<Response> {
    const token = localStorage.getItem('auth_token');
    
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (token) {
      (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
    }

    return fetch(url, {
      ...options,
      headers,
    });
  }

  /**
   * Obtém estatísticas gerais do sistema
   */
  async getDashboardStats(): Promise<DashboardStats> {
    const response = await this.authenticatedFetch(`${this.baseUrl}/stats`);
    
    if (!response.ok) {
      throw new Error('Erro ao carregar estatísticas do dashboard');
    }
    
    return response.json();
  }

  /**
   * Obtém série temporal de disparos
   * @param days - Número de dias (padrão: 30)
   */
  async getDispatchesTimeline(days: number = 30): Promise<DispatchesTimelineResponse> {
    const response = await this.authenticatedFetch(
      `${this.baseUrl}/dispatches-timeline?days=${days}`
    );
    
    if (!response.ok) {
      throw new Error('Erro ao carregar timeline de disparos');
    }
    
    return response.json();
  }

  /**
   * Obtém ranking de tenants mais ativos
   * @param limit - Número de resultados (padrão: 10)
   */
  async getTopTenants(limit: number = 10): Promise<TopTenantsResponse> {
    const response = await this.authenticatedFetch(
      `${this.baseUrl}/top-tenants?limit=${limit}`
    );
    
    if (!response.ok) {
      throw new Error('Erro ao carregar ranking de tenants');
    }
    
    return response.json();
  }
}

// Exportar instância singleton
export const dashboardApi = new DashboardApiService();
export default dashboardApi;

